import React from 'react'
import OutlinedInput from '@material-ui/core/OutlinedInput'
import InputAdornment from '@material-ui/core/InputAdornment'
import { makeStyles } from '@material-ui/styles'
import ClearIcon from 'components/material-symbol/icons/Clear'
import SearchIcon from 'components/material-symbol/icons/Search'

const useStyles = makeStyles(theme => ({
  root: {
    height: 40,
    backgroundColor: '#F4F6F8',
    borderRadius: 8,
    width: '100%',
    boxSizing: 'border-box',
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: `1px solid ${theme.palette.primary.main}`,
    },
    '& .MuiOutlinedInput-input': {
      padding: '8px 0',
      fontSize: '14px',
    },
    '& .MuiInputAdornment-root': {
      color: theme.palette.text.secondary,
    },
  },
}))

export default ({
  searchTerm,
  setSearchTerm,
  placeholder,
  style = null,
  fullWidth = false,
  className,
  ...props
}) => {
  const classes = useStyles()

  return (
    <OutlinedInput
      className={`${classes.root} ${className || ''}`}
      fullWidth={fullWidth}
      value={searchTerm}
      onChange={e => setSearchTerm(e.target.value)}
      placeholder={placeholder}
      style={
        style || (fullWidth ? undefined : { margin: '20px', width: '65%' })
      }
      startAdornment={
        <InputAdornment position="start">
          <SearchIcon fontSize="small" />
        </InputAdornment>
      }
      endAdornment={
        searchTerm.length ? (
          <InputAdornment
            onClick={() => setSearchTerm('')}
            position="end"
            style={{ cursor: 'pointer' }}
          >
            <ClearIcon fontSize="small" />
          </InputAdornment>
        ) : null
      }
      {...props}
    />
  )
}
